/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:51:56
 */
export default {
  lang: "英语",
  landing: {
    name1: "Open Carlcare",
    name2: "Reservation now",
    name3: "With Carlcare, you can check your order at any time.",
    name4: "Verification code",
    name5: "Slide to the right",
    name6: "Verification complete",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat price battery replacement service is designed for Infinix/Tecno/itel designated models.",
    name11: "Starting from 500 Shillings,you can get your battery replaced with no labor fee.",
    name12: 'The battery price may vary depending on the model. Please refer to the price list below for details.', // 小字标注
    name13: "Why Choose Carlcare Flat Price Battery Replacement ?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name18: "1-Month Warranty",
    name19: "Enjoy a 1‑month official warranty on your new battery.",
    name20: "Lower and Affordable Price",
    name21: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    name25: "1. The replaced battery under this promotion comes with a one-month official warranty.",
    name26: "2. This promotion is applicable for battery replacements only and is limited to specific models.",
    name27: "3. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name28: "4. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name29: "5. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare hotline at:709 698 888.",
    name30: "6. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare hotline at 02-8705-4200.",
    name31: "Carlcare Statements:",
    name32: "View Applicable Models & Price",
    name33: "Replacement",
    name34: "Starting from ₱500",
    name35: "View Applicable Models & Price",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
    name40: "Original Battery",
    name41: "Affordable Price",
    name42: "Free Labor Fee",
    name43: "Flat Price Battery Replacement",
    name44: "Starting from 500 Shillings",
  },
  order: {
    name1: "选择设备型号",
    name2: "故障描述：",
    name3: "点击选择服务网点",
    name4: "服务网点：",
    name5: "预约时间：",
    name6: "请详细描述你的设备问题！",
    name7: "点击选择到店时间",
    name8: "请准确填写你的个人信息，以便我们能够联系您！",
    name9: "支持的预约时间如下：",
    name10: "请填写您的联系方式",
    name11: "价格",
    name12: "个人信息：",
    name13: "请填写你的名字",
    name14: "提交",
    name15: "取消",
    name16: "确认",
  },
  shops: {
    name1: "基于您选择的品牌，以下的网点能够为您提供服务！",
    name2: "更多网点将上线！请关注我们！",
  },
  price: {
    name1: "品牌",
    name2: "机型",
    name3: "项目",
    name4: "价格",
    name5: "友情提示：",
    name6: "价格仅供参考，最终的价格取决于您的设备状况.",
    name7: "如果没有特殊的情况，价格显示的是本地的货币",
    name8: "对不起！当前地区没有价格信息",
    name11:"人工费",
    name12:"总价",
    name13: "如果人工成本是\"/\"，则表示人工成本需要向商店咨询。",
    item_main_board: "Mainboard",
    item_screen_frame: "Screen(Frame)",
    item_screen_screen_frame: "Secondary Screen(Frame)",
    item_touch_screen: "Touch Screen",
    item_camera: "Camera",
    item_fixed_focus_camera: "Fixed Focus Camera",
    item_auto_focus_camera: "Auto Focus Camera",
    item_screen: "Screen",
    item_secondary_screen: "Secondary Screen",
    item_fingerprint_module: "Fingerprint Module",
    item_speaker: "Speaker",
    item_receiver: "Receiver",
    item_small_board: "Small Board",
    item_battery_cover: "Battery Cover",
    item_battery: "Battery",
    item_charger: "Charger",
    item_usb_cable: "USB Cable",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "没有数据",
    name2: "服务提供商：",
    name3: "服务品牌：",
    name4: "电话号码：",
    name5: "订单数据：",
    name6: "服务评价",
    name7: "服务环境：",
    name8: "服务态度：",
    name9: "服务效率：",
    name10: "服务质量：",
    name11: "用户评价",
    name12:"至",
    name13:"关闭",
    name14:"地址:"
  },
  reserSuccess: {
    // name1:
    //   "打开 CarlcareApp",
    name1: "请截屏保存预约信息，作为优先服务的凭证。",
    name2: "提交成功！",
    name3: "1.清除数据",
    name4: "请提前备份个人重要信息",
    name5: "2.清除开机密码",
    name6: "在到服务网点之前，请",
    name7: "服务网点",
    name8: "预约时间",
    name9: "故障描述",
    name10: "设备型号",
    name11: "订单号",
    name12: "订单信息",
  },
  title: {
    name1: "支持下列国家：",
    name2: "选择型号",
    name3: "预约",
    name4: "服务网点详情",
    name5: "选择服务网点",
  },
  error: {
    name1: "无数据！请检查你的维修信息",
    name2: "需要更多帮助？请联系我们",
    name3: "对不起！目前所在地区没有服务网点",
    name4: "请先选择服务网点！",
    name5: "失败",
    name6: "请先选择机型!",
    name7: "详情",
    name8: "请详细描述您的需求",
    name9: "",
  },
  add1:{
    "name0": "values-zh-rCN",
    "name1": "您的订单已被确认，期待您的光临",
    "name2": "选择城市",
    "name3": "请输入%1$s位电话号码",
    "name4": "营业时间",
    "name5": "星期一",
    "name6": "星期二",
    "name7": "星期三",
    "name8": "星期四",
    "name9": "星期五",
    "name10": "星期六",
    "name11": "星期天",
    "name12": "输入国家名称并搜索"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "其他",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
    "name21": "Please allow Carlcare to get your location",
    "name22":"fail to get location, try again pls"
  },
  add3:{
    "name0": "English",
    "name1": "The courier will contact you later",
    "name2": "Home page",
    "name3": "Express details",
    "name4": "copy",
    "name5": "express number copied",
    "name6": "receiver info",
    "name7": "name",
    "name8": "phone number",
    "name9": "address",
    "name10": "pls enter your order number/phone number to view express detail",
    "name11": "Display only the last 30 days of orders",
    "name12": "order number",
    "name13": "create time",
    "name14": "delivery return",
    "name15": "shipper info",
    "name16": "submit",
    "name17": "Do you confirm to delivery the device back to the customer？",
    "name18": "back",
    "name19": "Cancel delivery",
    "name20": "Do you confirm to cancel delivery？",
    "name21": "the order can ‘t be canceled when it had been picked",
    "name23": "Review",
    "name24": "Device has benn deliveried",
    "name25": "Device has benn sent",
    "name26": "Repaired",
    "name27": "In maintenance",
    "name28": "Deliveried, the store has received device",
    "name29": "Waiting for pick-up",
    "name30": "Submit pick-up application",
    "name31": "delivery number:",
    "name32": "You cancel the order",
    "name33": "The courier cancel the order",
    "name33_1": "The admin cancel the order",
    "name34": "Delivery details",
    "name35": "pls enter verification code to cancel order",
    "name36": "send code",
    "name37": "resend",
    "name38": "code",
    "name39": "can‘t be edited",
    "name41": "Pls select the reason for cancellation",
    "name42": "Incorrect info",
    "name43": "Enter reason",
    "name44": "pls enter reason",
    "name45": "Sending",
    "name46": "Due to the distance out of reach, please contact us via WhatsApp, our team will serve you",
    "name47":"Pick Up Delivery Carlcare",
    "name48":"WhatsApp business account",
    "name49":"the store cancel the order",
    "name50":"the order has be canceled",
    "name51":"JNE Express",
    "name52":"Receiver Info",
    "name53":"Arrived",
    "name54":"On delivery",
    "name55":"Picked",
    "name56":"Go to pick-up location",
    "name57":"Order accepted",
    "name58":"Pending",
  },
  reasonlist:{
    name0:"Change the time of pick up",
    name1:"Incorrect address",
    name2:"Worried about the delivery process,phone will be lost and no compentation",
    name3:"Want to come to SC immediately",
    name4:"Privacy reason",
    name5:"Out of pick up delivery range",
    name6:"Courier doesn't come on time",
  },
  coupons: {
    name1:"Coupons",
    name2:"点击开始",
    name3:"打开Carlcare APP评价订单",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"选择服务",
    name7:"免费清洗",
    name8:"软件升级",
  },
  cancelorder:{
    "cancelReason0": "信息错误",
    "cancelReason1": "不能按时到店",
    "cancelReason2": "订单重复/非本人下单",
    "cancelReason3": "故障未复现",
    "cancelReason4": "为了测试、咨询、参加活动",
    "cancelReason5": "价格高",
    "cancelReason6": "Material shortage",
    "cancelReason7": "没有差异化服务",
    "cancelReason8": "The store is too far",
    "cancelReason9": "The store is closed",
    "cancelReason10": "网点服务态度差",
    "cancelReason11": "换机/维修其他品牌",
    "cancelReason12": "找不到网点",
    "cancelReason13": "其他",
    "cancelOrder": "Cancel Order",
    "reason_dialog_title": "Please tell us the reason of cancellation",
    "Cancel": "Cancel",
    "OK": "OK",
    "name1": "输入验证码",
    "name2": "验证码错误",
    "repair_reservation_detail_canceled": "订单已取消！",
    "purchase_cancel_dialog_content": "Do you confirm to cancel the order?",
    "yes": "Yes",
    "no": "No"
}
};
